<template>
  <div class="tw-flex tw-items-center">
    <router-link
      v-if="order.status !== 'DRAFT'"
      :to="{ name: 'recurring-order', params: { id: order.id } }"
      class="tw-underline tw-text-secondary-500 hover:tw-text-primary-600 tw-cursor-pointer tw-flex tw-items-center"
    >
      <span class="tw-mr-1">
        {{ order.recurring_number }}
      </span>
    </router-link>
    <span v-else>-</span>
  </div>
</template>

<script setup lang="ts">
import type { CellContext } from '@tanstack/vue-table';
import { computed } from 'vue';

const props = defineProps<{
  info: CellContext<any, any>;
}>();

const order = computed(() => props.info.row.original);
</script>
